var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_887_317)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 25.5,
    r: 16.5,
    fill: "#062F67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.379 29.7243C30.4313 29.783 30.4716 29.8513 30.4975 29.9256C30.5234 29.9998 30.5345 30.0784 30.53 30.1568C30.5255 30.2353 30.5055 30.3121 30.4713 30.3829C30.4371 30.4537 30.3893 30.517 30.3306 30.5693L29.3822 31.4148C29.2197 31.5756 29.027 31.7028 28.8152 31.7889C28.6034 31.875 28.3766 31.9183 28.148 31.9164C27.9109 31.9169 27.676 31.8706 27.4568 31.7801C27.2376 31.6896 27.0385 31.5567 26.8708 31.389L25.9475 30.5675C25.8889 30.5152 25.8411 30.452 25.8069 30.3813C25.7727 30.3106 25.7527 30.2339 25.7482 30.1555C25.739 29.9971 25.793 29.8416 25.8985 29.7231C26.004 29.6047 26.1522 29.533 26.3105 29.5238C26.3889 29.5192 26.4674 29.5301 26.5416 29.5559C26.6158 29.5817 26.6842 29.6219 26.7428 29.6741L27.5411 30.3881V25.9369C27.5411 25.7783 27.6041 25.6262 27.7162 25.5141C27.8284 25.4019 27.9805 25.3389 28.139 25.3389C28.2976 25.3389 28.4497 25.4019 28.5619 25.5141C28.674 25.6262 28.737 25.7783 28.737 25.9369V30.3887L29.5353 29.6759C29.6536 29.5705 29.809 29.5165 29.9672 29.5255C30.1254 29.5346 30.2735 29.6061 30.379 29.7243ZM30.1458 21.9671C30.0431 21.9352 29.9499 21.8783 29.8746 21.8016C29.7993 21.725 29.7441 21.6308 29.7141 21.5276C29.3975 20.5111 28.7508 19.6293 27.8765 19.0218C27.0022 18.4143 25.9502 18.1158 24.8872 18.1736C23.8241 18.2313 22.8107 18.6421 22.0074 19.3408C21.2041 20.0395 20.6569 20.9862 20.4523 22.031C20.2424 23.0876 20.4118 24.1844 20.9307 25.1284C20.3258 25.4407 19.834 25.9346 19.5242 26.5408C19.2145 27.147 19.1024 27.835 19.2038 28.5081C19.3596 29.2901 19.7783 29.9953 20.3903 30.5065C21.0022 31.0177 21.7706 31.3043 22.5679 31.3185H23.9534C24.1119 31.3185 24.264 31.2555 24.3762 31.1434C24.4883 31.0312 24.5513 30.8791 24.5513 30.7205C24.5513 30.5619 24.4883 30.4099 24.3762 30.2977C24.264 30.1856 24.1119 30.1226 23.9534 30.1226H22.5679C22.0572 30.1128 21.5646 29.9317 21.1693 29.6083C20.7739 29.2849 20.4987 28.8381 20.3877 28.3395C20.3228 27.9111 20.3937 27.4731 20.5903 27.087C20.787 26.7009 21.0997 26.3862 21.4844 26.1868C21.7586 26.0353 21.9621 25.7818 22.0509 25.4814C22.1396 25.1809 22.1065 24.8575 21.9586 24.5813C21.7264 24.1385 21.5893 23.652 21.5562 23.1532C21.523 22.6543 21.5945 22.1539 21.7661 21.6843C21.9376 21.2147 22.2055 20.7861 22.5524 20.426C22.8993 20.0659 23.3176 19.7824 23.7806 19.5935C24.2435 19.4046 24.7408 19.3145 25.2406 19.3291C25.7404 19.3437 26.2316 19.4625 26.6827 19.6781C27.1339 19.8936 27.535 20.2011 27.8603 20.5808C28.1857 20.9604 28.4281 21.4039 28.572 21.8827C28.6605 22.1714 28.8181 22.434 29.0312 22.6479C29.2443 22.8617 29.5065 23.0203 29.7948 23.1098C30.5759 23.3474 31.2519 23.8457 31.7102 24.5214C32.1685 25.1971 32.3814 26.0094 32.3134 26.8231C32.2683 27.4557 32.0372 28.0609 31.649 28.5625C31.5524 28.6883 31.5096 28.8473 31.5302 29.0046C31.5508 29.1618 31.633 29.3045 31.7588 29.4011C31.8845 29.4978 32.0435 29.5405 32.2008 29.52C32.3581 29.4994 32.5007 29.4172 32.5974 29.2914C33.1242 28.6046 33.44 27.7794 33.5063 26.9163C33.5966 25.8315 33.3123 24.7484 32.7008 23.8478C32.0892 22.9471 31.1875 22.2833 30.1458 21.9671Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_887_317",
    x: 0,
    y: 0,
    width: 53,
    height: 53,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_887_317"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_887_317",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.70444f05ece9823db7b48478e161e512.svg";
export { ForwardRef as ReactComponent };